import { getBillingCodesWriteOffs } from '../../../neb-api-client/src/billing-codes';

export const getAdjustments = async (optOutLoadingIndicator = false) =>
  (await getBillingCodesWriteOffs({}, optOutLoadingIndicator))
    .filter(a => a.active && a.forPatient && a.code !== 'Pkg')
    .sort((a, b) => a.code.localeCompare(b.code));
